const crypto = require('crypto');  //引用AES源码js

//加密方法
function Encrypt(data) {
    const cipher = crypto.createCipheriv('aes-128-cbc', '2a198471ea775bae', 'tencentkedaibiao');
    let crypted = cipher.update(data, 'utf8', 'binary');
    crypted += cipher.final('binary');
    crypted = Buffer.from(crypted, 'binary');
    crypted = crypted.toString('base64');
    return crypted;
}

export default {
    Encrypt
    // install(Vue,options){
    //     // 在 vue 中全局注册
    //     Vue.prototype.Encrypt = Encrypt
    // }
}